__turbopack_context__.v({
  "className": "reem_kufi_bbf5f9a0-module__0NEuAG__className",
  "variable": "reem_kufi_bbf5f9a0-module__0NEuAG__variable",
});
